/* ============================================================
   HELLA GOOD CUP — Theme JS v7 — Full Funnel
   New/upgraded features:
   - Split-panel email popup v7 (Mautic Form 4 + TextLink SMS)
   - Gamified quiz v7 with image options
   - Cart drawer upsell section
   - Subscribe page coffee scroll + plan calculator
   - Free Coffee funnel v7
   - Mautic contact helper (all forms)
   - TextLink SMS opt-in helper
   - Stripe checkout helper (one-time + subscription)
   ============================================================ */
(function () {
  'use strict';

  /* ── Utility ─────────────────────────────────────────────── */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  /* ── Mautic Helper ───────────────────────────────────────── */
  var MAUTIC_BASE = 'https://mautic.brewsandteas.com';
  function mauticSubmit(formId, fields) {
    var data = new FormData();
    data.append('mauticform[formId]', String(formId));
    data.append('mauticform[return]', '');
    data.append('mauticform[messenger]', '1');
    Object.keys(fields).forEach(function(k) {
      if (fields[k]) data.append('mauticform[' + k + ']', fields[k]);
    });
    fetch(MAUTIC_BASE + '/form/submit?formId=' + formId, {
      method: 'POST', body: data, mode: 'no-cors'
    }).catch(function() {});
  }

  /* ── TextLink SMS Helper ─────────────────────────────────── */
  function textlinkOptIn(phone, email, tags) {
    // TextLink SMS opt-in via their API
    var payload = { phone: phone, email: email || '', tags: tags || ['hgc-popup'] };
    fetch('https://api.textlinksms.com/v1/contacts', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      mode: 'no-cors'
    }).catch(function() {});
  }

  /* ── Shopify Cart Helpers ────────────────────────────────── */
  function addToCart(variantId, qty, props, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1, properties: props || {} })
    }).then(function(r) { return r.json(); })
      .then(function(d) { if (callback) callback(null, d); })
      .catch(function(e) { if (callback) callback(e); });
  }
  function getCart(callback) {
    fetch('/cart.js').then(function(r) { return r.json(); })
      .then(function(d) { callback(null, d); })
      .catch(function(e) { callback(e); });
  }
  function updateCartItem(key, qty, callback) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r) { return r.json(); })
      .then(function(d) { if (callback) callback(null, d); })
      .catch(function(e) { if (callback) callback(e); });
  }
  function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }

  /* ── Cart Drawer ─────────────────────────────────────────── */
  var cartDrawer = $('#cart-drawer');
  var cartOverlay = $('#cart-overlay') || $('#site-overlay');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) { cartOverlay.classList.add('is-open'); }
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) { cartOverlay.classList.remove('is-open'); }
    document.body.style.overflow = '';
  }
  function refreshCartDrawer() {
    getCart(function(err, cart) {
      if (err || !cart) return;
      updateCartCount(cart.item_count);
      renderCartItems(cart);
      updateShippingBar(cart.total_price);
      renderCartUpsell(cart);
    });
  }
  function updateCartCount(count) {
    var countEl = $('#cart-count');
    if (countEl) {
      countEl.textContent = count;
      countEl.style.display = count > 0 ? 'flex' : 'none';
    }
  }
  function updateShippingBar(totalCents) {
    var threshold = 4900;
    var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
    var fill = $('#cart-shipping-fill');
    var msg = $('#cart-shipping-msg');
    if (fill) fill.style.width = pct + '%';
    if (msg) {
      if (totalCents >= threshold) {
        msg.textContent = '🎉 You qualify for FREE shipping!';
      } else {
        var remaining = ((threshold - totalCents) / 100).toFixed(2);
        msg.textContent = 'Add $' + remaining + ' more for FREE shipping';
      }
    }
  }
  function renderCartItems(cart) {
    var list = $('#cart-items-list');
    if (!list) return;
    if (!cart.items || cart.items.length === 0) {
      list.innerHTML = '<div class="cart-empty"><p>Your cart is empty</p><a href="/collections/all" class="btn-primary" style="margin-top:16px;display:inline-block;">Shop Coffees →</a></div>';
      var footer = $('#cart-footer');
      if (footer) footer.style.display = 'none';
      return;
    }
    var footer = $('#cart-footer');
    if (footer) footer.style.display = '';
    list.innerHTML = cart.items.map(function(item) {
      return '<div class="cart-item" data-key="' + item.key + '">' +
        '<img src="' + item.image + '" alt="' + item.title + '" class="cart-item-img" />' +
        '<div class="cart-item-info">' +
          '<p class="cart-item-title">' + item.product_title + '</p>' +
          '<p class="cart-item-variant">' + (item.variant_title !== 'Default Title' ? item.variant_title : '') + '</p>' +
          '<div class="cart-item-qty-row">' +
            '<button class="cart-qty-btn" data-key="' + item.key + '" data-delta="-1">−</button>' +
            '<span class="cart-qty-num">' + item.quantity + '</span>' +
            '<button class="cart-qty-btn" data-key="' + item.key + '" data-delta="1">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-item-price">' + formatMoney(item.line_price) + '</div>' +
      '</div>';
    }).join('');
    var subtotalEl = $('#cart-subtotal');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    // Qty buttons
    $$('.cart-qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.dataset.key;
        var delta = parseInt(btn.dataset.delta);
        var qtyEl = btn.parentNode.querySelector('.cart-qty-num');
        var currentQty = parseInt(qtyEl ? qtyEl.textContent : '1');
        var newQty = Math.max(0, currentQty + delta);
        updateCartItem(key, newQty, function() { refreshCartDrawer(); });
      });
    });
  }
  function renderCartUpsell(cart) {
    var upsellSection = $('#cart-upsell-section');
    if (!upsellSection) return;
    // Show a relevant upsell product not already in cart
    var cartHandles = (cart.items || []).map(function(i) { return i.handle; });
    var upsells = [
      { name: 'Smith River Blend', price: '$28.80', img: 'https://cdn.shopify.com/s/files/1/0941/4387/3306/files/SmithRiver3.png', handle: 'smith-river-blend', variantId: '' },
      { name: 'Functional Mushroom', price: '$35.80', img: 'https://cdn.shopify.com/s/files/1/0941/4387/3306/files/FuntionalMushroom3.png', handle: 'functional-mushroom-coffee-blend', variantId: '' },
      { name: 'High Lakes Blend', price: '$28.80', img: 'https://cdn.shopify.com/s/files/1/0941/4387/3306/files/HighLakes3.png', handle: 'high-lakes-blend', variantId: '' },
    ];
    var upsell = upsells.find(function(u) { return cartHandles.indexOf(u.handle) === -1; });
    if (!upsell || cart.item_count === 0) { upsellSection.style.display = 'none'; return; }
    upsellSection.style.display = '';
    upsellSection.innerHTML = '<div class="cart-upsell-title">YOU MIGHT ALSO LIKE</div>' +
      '<div class="cart-upsell-item">' +
        '<img src="' + upsell.img + '" alt="' + upsell.name + '" class="cart-upsell-img" />' +
        '<div class="cart-upsell-info"><div class="cart-upsell-name">' + upsell.name + '</div><div class="cart-upsell-price">' + upsell.price + '</div></div>' +
        '<a href="/products/' + upsell.handle + '" class="cart-upsell-add">Add +</a>' +
      '</div>';
  }

  // Cart open/close events
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-close-cart]')) { closeCart(); }
    if (e.target === cartOverlay) { closeCart(); }
  });

  /* ── Email Popup v7 — Split Panel ────────────────────────── */
  var popup = $('#email-popup-v7');
  var popupShown = false;
  function showPopupV7() {
    if (popupShown || !popup) return;
    if (window.location.pathname.indexOf('/checkout') !== -1) return;
    if (window.location.pathname.indexOf('/cart') !== -1) return;
    try { if (localStorage.getItem('hgc_popup_submitted')) return; } catch(e) {}
    try { if (sessionStorage.getItem('hgc_popup_dismissed')) return; } catch(e) {}
    popupShown = true;
    popup.classList.add('active');
    document.body.style.overflow = 'hidden';
    window.scrollTo({ top: 0, behavior: 'instant' });
  }
  // Exit intent
  document.addEventListener('mouseleave', function(e) { if (e.clientY <= 10) showPopupV7(); });
  // Fallback timer
  setTimeout(showPopupV7, 45000);

  function closePopupV7(dismissed) {
    if (!popup) return;
    popup.classList.remove('active');
    document.body.style.overflow = '';
    if (dismissed) {
      try { sessionStorage.setItem('hgc_popup_dismissed', '1'); } catch(e) {}
    }
  }

  on($('#popup-v7-close'), 'click', function() { closePopupV7(true); });
  on($('#popup-v7-decline'), 'click', function() { closePopupV7(true); });
  on(popup, 'click', function(e) { if (e.target === popup) closePopupV7(true); });

  var popupForm = $('#popup-v7-form');
  if (popupForm) {
    popupForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = ($('#popup-v7-email') || {}).value || '';
      var phone = ($('#popup-v7-phone') || {}).value || '';
      if (!email) return;
      // Submit to Mautic Form 4
      mauticSubmit(4, { email: email, phone: phone });
      // TextLink SMS opt-in if phone provided
      if (phone) textlinkOptIn(phone, email, ['hgc-popup', 'hgc-15off']);
      // Show success
      if (popupForm) popupForm.style.display = 'none';
      var success = $('#popup-v7-success');
      if (success) success.style.display = 'block';
      try { localStorage.setItem('hgc_popup_submitted', '1'); } catch(e) {}
      setTimeout(function() { closePopupV7(false); }, 4500);
    });
  }

  /* ── Quiz v7 — Gamified ──────────────────────────────────── */
  var quizModal = $('#quiz-modal-v7');
  var quizStep = 0;
  var quizAnswers = {};
  var quizSteps = [
    {
      q: 'How do you take your coffee?',
      key: 'style',
      options: [
        { emoji: '☕', label: 'Black', sub: 'Pure & unadulterated' },
        { emoji: '🥛', label: 'With milk', sub: 'Creamy & smooth' },
        { emoji: '🧊', label: 'Iced', sub: 'Cold & refreshing' },
        { emoji: '🍫', label: 'Flavored', sub: 'Sweet & indulgent' },
      ]
    },
    {
      q: 'What roast level do you prefer?',
      key: 'roast',
      options: [
        { emoji: '🌤️', label: 'Light', sub: 'Bright & fruity' },
        { emoji: '⛅', label: 'Medium', sub: 'Balanced & smooth' },
        { emoji: '🌑', label: 'Dark', sub: 'Bold & rich' },
        { emoji: '🤷', label: 'Surprise me', sub: 'I\'m adventurous' },
      ]
    },
    {
      q: 'What\'s your morning vibe?',
      key: 'vibe',
      options: [
        { emoji: '🧘', label: 'Calm & focused', sub: 'Gentle start' },
        { emoji: '⚡', label: 'Full send', sub: 'Maximum energy' },
        { emoji: '🌿', label: 'Health-first', sub: 'Functional benefits' },
        { emoji: '☕', label: 'Pure ritual', sub: 'Coffee is my religion' },
      ]
    },
    {
      q: 'How much do you brew?',
      key: 'volume',
      options: [
        { emoji: '1️⃣', label: '1 cup/day', sub: 'Light drinker' },
        { emoji: '2️⃣', label: '2–3 cups/day', sub: 'Regular drinker' },
        { emoji: '☕', label: '4+ cups/day', sub: 'Serious enthusiast' },
        { emoji: '👨‍👩‍👧', label: 'Whole household', sub: 'Family or office' },
      ]
    },
    {
      q: 'What matters most to you?',
      key: 'priority',
      options: [
        { emoji: '🌍', label: 'Ethical sourcing', sub: 'Fair trade & traceable' },
        { emoji: '💰', label: 'Best value', sub: 'Quality per dollar' },
        { emoji: '🔬', label: 'Unique flavors', sub: 'Specialty & exotic' },
        { emoji: '❤️', label: 'Social impact', sub: 'Give back with every cup' },
      ]
    }
  ];

  function openQuizV7() {
    if (!quizModal) return;
    quizStep = 0;
    quizAnswers = {};
    renderQuizStep();
    quizModal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
  function closeQuizV7() {
    if (!quizModal) return;
    quizModal.style.display = 'none';
    document.body.style.overflow = '';
  }
  function renderQuizStep() {
    var stepData = quizSteps[quizStep];
    if (!stepData) { showQuizResult(); return; }
    var body = $('#quiz-v7-body');
    if (!body) return;
    var pct = Math.round(((quizStep) / quizSteps.length) * 100);
    body.innerHTML =
      '<div class="quiz-v7-progress"><div class="quiz-v7-progress-fill" style="width:' + pct + '%"></div></div>' +
      '<p style="font-family:\'DM Sans\',sans-serif;font-size:0.8rem;color:#8D6E63;margin-bottom:8px;">Question ' + (quizStep+1) + ' of ' + quizSteps.length + '</p>' +
      '<h3 style="font-family:\'Playfair Display\',serif;font-size:1.4rem;font-weight:900;color:#3E2723;margin-bottom:24px;">' + stepData.q + '</h3>' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;">' +
        stepData.options.map(function(opt, i) {
          return '<div class="quiz-v7-option" data-key="' + stepData.key + '" data-val="' + opt.label + '" style="padding:20px;text-align:center;">' +
            '<span class="quiz-v7-option-emoji">' + opt.emoji + '</span>' +
            '<div class="quiz-v7-option-label">' + opt.label + '</div>' +
            '<div class="quiz-v7-option-sub">' + opt.sub + '</div>' +
          '</div>';
        }).join('') +
      '</div>';
    $$('.quiz-v7-option', body).forEach(function(opt) {
      opt.addEventListener('click', function() {
        quizAnswers[opt.dataset.key] = opt.dataset.val;
        quizStep++;
        renderQuizStep();
      });
    });
  }
  function showQuizResult() {
    var body = $('#quiz-v7-body');
    if (!body) return;
    // Determine recommendation based on answers
    var rec = 'Smith River Blend';
    var recHandle = 'smith-river-blend';
    var recImg = 'https://cdn.shopify.com/s/files/1/0941/4387/3306/files/SmithRiver3.png';
    var recDesc = 'Smooth, balanced, and crowd-pleasing — our most popular medium roast.';
    if (quizAnswers.vibe === 'Health-first') {
      rec = 'Functional Mushroom Coffee'; recHandle = 'functional-mushroom-coffee-blend';
      recImg = 'https://cdn.shopify.com/s/files/1/0941/4387/3306/files/FuntionalMushroom3.png';
      recDesc = 'Lion\'s Mane + Chaga for focused energy without the crash.';
    } else if (quizAnswers.roast === 'Light') {
      rec = 'High Lakes Blend'; recHandle = 'high-lakes-blend';
      recImg = 'https://cdn.shopify.com/s/files/1/0941/4387/3306/files/HighLakes3.png';
      recDesc = 'Clean, delicate, and wildly complex — our lightest roast.';
    } else if (quizAnswers.roast === 'Dark') {
      rec = 'Cascades Blend'; recHandle = 'cascades-blend';
      recImg = 'https://cdn.shopify.com/s/files/1/0941/4387/3306/files/Cascades3.png';
      recDesc = 'Bold, smoky, and deeply satisfying — our darkest roast.';
    } else if (quizAnswers.roast === 'Medium') {
      rec = 'Smith River Blend'; recHandle = 'smith-river-blend';
      recImg = 'https://cdn.shopify.com/s/files/1/0941/4387/3306/files/SmithRiver3.png';
      recDesc = 'Smooth and balanced — the perfect everyday medium roast.';
    }
    body.innerHTML =
      '<div style="text-align:center;padding:20px 0;">' +
        '<div style="font-size:3rem;margin-bottom:12px;">☕</div>' +
        '<h3 style="font-family:\'Playfair Display\',serif;font-size:1.5rem;font-weight:900;color:#3E2723;margin-bottom:8px;">Your Perfect Match</h3>' +
        '<img src="' + recImg + '" alt="' + rec + '" style="width:160px;height:180px;object-fit:contain;margin:16px auto;display:block;filter:drop-shadow(0 8px 16px rgba(0,0,0,0.15));" />' +
        '<h4 style="font-family:\'Playfair Display\',serif;font-size:1.2rem;font-weight:700;color:#3E2723;margin-bottom:8px;">' + rec + '</h4>' +
        '<p style="font-family:\'DM Sans\',sans-serif;font-size:0.9rem;color:#8D6E63;margin-bottom:24px;">' + recDesc + '</p>' +
        '<div style="display:flex;gap:12px;justify-content:center;flex-wrap:wrap;">' +
          '<a href="/products/' + recHandle + '" class="v7-btn-dark" onclick="closeQuizV7()">Shop This Coffee →</a>' +
          '<a href="/collections/all" class="v7-btn-outline" style="color:#3E2723;border-color:rgba(62,39,35,0.25);" onclick="closeQuizV7()">See All Coffees</a>' +
        '</div>' +
      '</div>';
  }

  // Quiz open triggers
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-open-quiz]')) { e.preventDefault(); openQuizV7(); }
    if (e.target.closest('[data-close-quiz]')) { closeQuizV7(); }
    if (e.target === quizModal) { closeQuizV7(); }
  });
  window.closeQuizV7 = closeQuizV7;

  /* ── Subscribe Page v7 ───────────────────────────────────── */
  if (document.body.classList.contains('template-page') && window.location.pathname.indexOf('subscribe') !== -1) {
    var BASE_PRICES = { single: 31.80, double: 63.60, triple: 95.40 };
    var DISCOUNTS = { monthly: 0.15, prepay3: 0.18, prepay6: 0.22 };
    var MONTHS = { monthly: 1, prepay3: 3, prepay6: 6 };
    var selectedCycle = 'monthly';
    var selectedPlan = 'double';
    var selectedCoffee = '';

    function calcPrice(plan, cycle) {
      var base = BASE_PRICES[plan] || 31.80;
      var disc = DISCOUNTS[cycle] || 0.15;
      var months = MONTHS[cycle] || 1;
      var perCycle = Math.round(base * (1 - disc) * 100) / 100;
      var total = Math.round(perCycle * months * 100) / 100;
      var savings = Math.round((base * months - total) * 100) / 100;
      return { perCycle: perCycle, total: total, savings: savings };
    }

    function updateSubUI() {
      $$('.sub-cycle-tab').forEach(function(tab) {
        tab.classList.toggle('active', tab.dataset.cycle === selectedCycle);
      });
      $$('.sub-plan-card').forEach(function(card) {
        var plan = card.dataset.plan;
        card.classList.toggle('selected', plan === selectedPlan);
        var prices = calcPrice(plan, selectedCycle);
        var priceEl = card.querySelector('.sub-plan-price');
        var savingsEl = card.querySelector('.sub-plan-savings');
        if (priceEl) priceEl.textContent = '$' + prices.perCycle.toFixed(2);
        if (savingsEl) savingsEl.textContent = 'Save $' + prices.savings.toFixed(2) + (MONTHS[selectedCycle] > 1 ? ' total' : ' per bag');
      });
    }

    $$('.sub-cycle-tab').forEach(function(tab) {
      tab.addEventListener('click', function() {
        selectedCycle = tab.dataset.cycle;
        updateSubUI();
      });
    });
    $$('.sub-plan-card').forEach(function(card) {
      card.addEventListener('click', function() {
        selectedPlan = card.dataset.plan;
        updateSubUI();
      });
    });
    $$('.sub-coffee-card').forEach(function(card) {
      card.addEventListener('click', function(e) {
        e.preventDefault();
        selectedCoffee = card.dataset.handle;
        $$('.sub-coffee-card').forEach(function(c) { c.classList.remove('selected'); });
        card.classList.add('selected');
      });
    });

    var subCheckoutBtn = $('#sub-checkout-btn');
    if (subCheckoutBtn) {
      subCheckoutBtn.addEventListener('click', function() {
        var prices = calcPrice(selectedPlan, selectedCycle);
        var params = new URLSearchParams({
          plan: selectedPlan,
          cycle: selectedCycle,
          coffee: selectedCoffee,
          amount: prices.total.toFixed(2)
        });
        window.location.href = '/pages/subscribe-checkout?' + params.toString();
      });
    }
    updateSubUI();
  }

  /* ── Free Coffee Funnel v7 ───────────────────────────────── */
  var fcForm = $('#free-coffee-form-v7');
  if (fcForm) {
    fcForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var name = ($('#fc-name') || {}).value || '';
      var email = ($('#fc-email') || {}).value || '';
      var phone = ($('#fc-phone') || {}).value || '';
      var address = ($('#fc-address') || {}).value || '';
      if (!name || !email) return;
      mauticSubmit(5, { firstname: name, email: email, phone: phone, address1: address });
      if (phone) textlinkOptIn(phone, email, ['hgc-free-coffee', 'hgc-funnel']);
      window.location.href = '/pages/free-coffee-checkout?email=' + encodeURIComponent(email) + '&name=' + encodeURIComponent(name);
    });
  }

  /* ── Cart Abandonment Beacon ─────────────────────────────── */
  var cartAbandonTimer;
  var cartAbandonFired = false;
  function resetAbandonTimer() {
    clearTimeout(cartAbandonTimer);
    cartAbandonTimer = setTimeout(function() {
      if (cartAbandonFired) return;
      getCart(function(err, cart) {
        if (err || !cart || cart.item_count === 0) return;
        var email = '';
        try { email = localStorage.getItem('hgc_customer_email') || ''; } catch(e) {}
        if (!email) return;
        cartAbandonFired = true;
        mauticSubmit(6, { email: email, cart_total: formatMoney(cart.total_price) });
      });
    }, 30000);
  }
  document.addEventListener('mousemove', resetAbandonTimer);
  document.addEventListener('keydown', resetAbandonTimer);
  resetAbandonTimer();

  /* ── OTO Countdown Timer ─────────────────────────────────── */
  var countdownEl = $('#oto-countdown');
  if (countdownEl) {
    var endTime;
    try { endTime = parseInt(sessionStorage.getItem('hgc_oto_end') || '0'); } catch(e) { endTime = 0; }
    if (!endTime || endTime < Date.now()) {
      endTime = Date.now() + 15 * 60 * 1000;
      try { sessionStorage.setItem('hgc_oto_end', String(endTime)); } catch(e) {}
    }
    var countdownInterval = setInterval(function() {
      var remaining = Math.max(0, endTime - Date.now());
      var mins = Math.floor(remaining / 60000);
      var secs = Math.floor((remaining % 60000) / 1000);
      countdownEl.textContent = (mins < 10 ? '0' : '') + mins + ':' + (secs < 10 ? '0' : '') + secs;
      if (remaining === 0) {
        clearInterval(countdownInterval);
        countdownEl.textContent = '00:00';
      }
    }, 1000);
  }

  /* ── Scroll Restoration Fix ──────────────────────────────── */
  if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; }
  window.addEventListener('load', function() { window.scrollTo(0, 0); });

  /* ── Mobile Nav ──────────────────────────────────────────── */
  on($('#mobile-nav-toggle'), 'click', function() {
    var nav = $('#mobile-nav');
    if (nav) nav.classList.toggle('is-open');
    document.body.style.overflow = nav && nav.classList.contains('is-open') ? 'hidden' : '';
  });
  on($('#mobile-nav-close'), 'click', function() {
    var nav = $('#mobile-nav');
    if (nav) nav.classList.remove('is-open');
    document.body.style.overflow = '';
  });

  /* ── Grind Selector ──────────────────────────────────────── */
  $$('.grind-selector-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var group = btn.closest('.grind-selector');
      if (!group) return;
      $$('.grind-selector-btn', group).forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var variantInput = group.closest('form') && group.closest('form').querySelector('[name="id"]');
      if (variantInput && btn.dataset.variantId) {
        variantInput.value = btn.dataset.variantId;
      }
    });
  });

  /* ── Brew Guides Filter ──────────────────────────────────── */
  $$('.brew-filter-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      $$('.brew-filter-btn').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var filter = btn.dataset.filter;
      $$('.brew-guide-card').forEach(function(card) {
        card.style.display = (filter === 'all' || card.dataset.method === filter) ? '' : 'none';
      });
    });
  });

  /* ── Recipes Filter ──────────────────────────────────────── */
  $$('.recipe-filter-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      $$('.recipe-filter-btn').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var filter = btn.dataset.filter;
      $$('.recipe-card').forEach(function(card) {
        card.style.display = (filter === 'all' || card.dataset.coffee === filter) ? '' : 'none';
      });
    });
  });

  /* ── Smooth scroll for anchor links ──────────────────────── */
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var target = document.querySelector(link.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

})();
